/* tslint:disable */
/* eslint-disable */
/**
 * RCS.Carbon.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CacheEntryInfo } from './CacheEntryInfo';
import {
    CacheEntryInfoFromJSON,
    CacheEntryInfoFromJSONTyped,
    CacheEntryInfoToJSON,
    CacheEntryInfoToJSONTyped,
} from './CacheEntryInfo';

/**
 * 
 * @export
 * @interface CacheStatsResponse
 */
export interface CacheStatsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CacheStatsResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    memoryHits: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    misses: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    evictions: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    hitRatePercent?: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    totalFilesInMemory: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    totalBytesInMemory: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    totalMegabytesInMemory: number;
    /**
     * 
     * @type {number}
     * @memberof CacheStatsResponse
     */
    maxCacheMegabytes: number;
    /**
     * 
     * @type {Array<CacheEntryInfo>}
     * @memberof CacheStatsResponse
     */
    entries?: Array<CacheEntryInfo>;
}

/**
 * Check if a given object implements the CacheStatsResponse interface.
 */
export function instanceOfCacheStatsResponse(value: object): value is CacheStatsResponse {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('memoryHits' in value) || value['memoryHits'] === undefined) return false;
    if (!('misses' in value) || value['misses'] === undefined) return false;
    if (!('evictions' in value) || value['evictions'] === undefined) return false;
    if (!('totalFilesInMemory' in value) || value['totalFilesInMemory'] === undefined) return false;
    if (!('totalBytesInMemory' in value) || value['totalBytesInMemory'] === undefined) return false;
    if (!('totalMegabytesInMemory' in value) || value['totalMegabytesInMemory'] === undefined) return false;
    if (!('maxCacheMegabytes' in value) || value['maxCacheMegabytes'] === undefined) return false;
    return true;
}

export function CacheStatsResponseFromJSON(json: any): CacheStatsResponse {
    return CacheStatsResponseFromJSONTyped(json, false);
}

export function CacheStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CacheStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'memoryHits': json['memoryHits'],
        'misses': json['misses'],
        'evictions': json['evictions'],
        'hitRatePercent': json['hitRatePercent'] == null ? undefined : json['hitRatePercent'],
        'totalFilesInMemory': json['totalFilesInMemory'],
        'totalBytesInMemory': json['totalBytesInMemory'],
        'totalMegabytesInMemory': json['totalMegabytesInMemory'],
        'maxCacheMegabytes': json['maxCacheMegabytes'],
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(CacheEntryInfoFromJSON)),
    };
}

export function CacheStatsResponseToJSON(json: any): CacheStatsResponse {
    return CacheStatsResponseToJSONTyped(json, false);
}

export function CacheStatsResponseToJSONTyped(value?: CacheStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'memoryHits': value['memoryHits'],
        'misses': value['misses'],
        'evictions': value['evictions'],
        'hitRatePercent': value['hitRatePercent'],
        'totalFilesInMemory': value['totalFilesInMemory'],
        'totalBytesInMemory': value['totalBytesInMemory'],
        'totalMegabytesInMemory': value['totalMegabytesInMemory'],
        'maxCacheMegabytes': value['maxCacheMegabytes'],
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(CacheEntryInfoToJSON)),
    };
}

